import React, { useState } from 'react';
import { Video } from 'lucide-react';
import DOMPurify from 'dompurify';
import { Link } from 'react-router-dom';

const extractYouTubeId = (url) => {
  if (!url) return null;
  const m = url.match(/(?:v=|v\/|embed\/|youtu.be\/)([A-Za-z0-9_-]{6,})/);
  return m ? m[1] : null;
};

const NewsList = ({ news = [] }) => {
  const [expandedIds, setExpandedIds] = useState([]);

  const isExpanded = (id) => expandedIds.includes(id);
  const toggleExpanded = (id) => {
    setExpandedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };

  const truncate = (text, n = 250) => {
    if (!text) return '';
    if (text.length <= n) return text;
    return text.slice(0, n).trim() + '…';
  };

  return (
    <div className="news-list">
      {news.map(item => {
        // Safely obtain a displayable createdAt string from Firestore Timestamp or Date
        let createdAtText = '';
        try {
          const ts = item.createdAt;
          if (ts) {
            if (typeof ts.toDate === 'function') {
              createdAtText = ts.toDate().toLocaleString();
            } else if (ts instanceof Date) {
              createdAtText = ts.toLocaleString();
            } else if (typeof ts === 'string') {
              createdAtText = ts;
            }
          }
        } catch (e) {
          createdAtText = '';
        }

        const fullContent = item.content || '';
        const excerpt = truncate(fullContent.replace(/<[^>]*>?/gm, ''), 300); // truncate plain text
        const showToggle = fullContent.length > 300;

        return (
          <div key={item.id} className="news-item">
            <h4>{item.title}</h4>

            {showToggle ? (
              <div className="news-content">
                <p className={`excerpt ${isExpanded(item.id) ? 'hidden' : ''}`}>{excerpt}</p>
                <div className={`full ${isExpanded(item.id) ? 'visible' : 'hidden'}`} dangerouslySetInnerHTML={{ __html: isExpanded(item.id) ? DOMPurify.sanitize(fullContent) : '' }} />
                <button className="news-toggle-btn" onClick={() => toggleExpanded(item.id)}>
                  {isExpanded(item.id) ? 'Mostrar menos' : 'Leer más'}
                </button>
              </div>
            ) : (
              <div className="full" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(fullContent) }} />
            )}

            {item.videoUrl && (
              <div className="news-video">
                {(() => {
                  const ytId = extractYouTubeId(item.videoUrl);
                  if (ytId) {
                    const thumb = `https://img.youtube.com/vi/${ytId}/mqdefault.jpg`;
                    return (
                      <Link to={`/dashboard/news/${item.id}`} className="news-video-thumb-link">
                        <img src={thumb} alt="miniatura" className="news-video-thumb" />
                      </Link>
                    );
                  }
                  return (
                    <Video size={16}/> 
                  );
                })()}
                <Link to={`/dashboard/news/${item.id}`} className="news-video-link">Abrir noticia</Link>
              </div>
            )}
            <span className="news-date">{createdAtText}</span>
          </div>
        );
      })}
    </div>
  );
};

export default NewsList;
